import { render, staticRenderFns } from "./contentDiscussionBoard.vue?vue&type=template&id=7401ce0a&"
import script from "./contentDiscussionBoard.vue?vue&type=script&lang=js&"
export * from "./contentDiscussionBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports